@switch (step) {
  @case (dialogSteps.ENROLL) {
    @if (isLearningPlansRoute) {
      <app-learning-plan-enrollment-container
        class="h-full"
        (userCreationButtonClickEvent)="showUserCreationContent()"
        (addLicensesButtonClickEvent)="onAddLicensesButtonClick()"
        (studentSuccessfullyEnrolledEvent)="closeDialog()"
        (abortButtonClickEvent)="closeDialog()"
      ></app-learning-plan-enrollment-container>
    } @else {
      <app-course-enrollment-container
        class="h-full"
        (userCreationButtonClickEvent)="showUserCreationContent()"
        (addLicensesButtonClickEvent)="onAddLicensesButtonClick()"
        (studentSuccessfullyEnrolledEvent)="closeDialog()"
        (abortButtonClickEvent)="closeDialog()"
      ></app-course-enrollment-container>
    }
  }
  @case (dialogSteps.CREATE) {
    <app-user-creation-container
      class="h-full"
      (userSuccessfullyCreatedEvent)="handleUserSuccessfullyCreatedEvent()"
      (backButtonClickEvent)="goBack()"
      (csvUploadButtonClickEvent)="showCsvUploadContent()"
    />
  }
  @case (dialogSteps.CSV) {
    <app-user-csv-upload-container
      class="h-full"
      (backButtonClickEvent)="showUserCreationContent()"
      (usersSuccessfullyCreatedEvent)="handleUserSuccessfullyCreatedEvent()"
    ></app-user-csv-upload-container>
  }
}
